
import styled from 'styled-components';
import { t } from '@lingui/core/macro';

const List = styled.div`
  list-style: none;
  text-align: left;
`;

const ListItem = styled.li`
  padding: 0.5rem;
  cursor: pointer;
  &:hover {
    background-color: #f9f9f9;
    color: #333;
  }
  &.active {
    background-color: #f9f9f9;
    color: #333;
  }
`;

/**
 * A component that displays a result list
 *
 * @param {object} props
 * @returns {JSX.Element}
 */
 const ResultList= (options) => {

    /**
   * A function that handles an image download
   * @param {string} name - A story name
   * @param {string} searchTerm - A search term string
   * @returns {JSX.Element} Return a list element
   */
  const matchedTerm = (name, searchTerm) => {
    const index = name.toLowerCase().indexOf(searchTerm.toLowerCase());
    if (index === -1) {
      return name;
    }
    return (
      <>
        {name.substring(0, index)}
        <b>{name.substring(index, index + searchTerm.length)}</b>
        {name.substring(index + searchTerm.length)}
      </>
    );
  };

  if (options.loading) {
    return <List>{t`Loading`}...</List>;
  }

  if(options.result=== "undefined"){
        return <List>{t`No results found`}</List>;
  }

  if (options.results.length === 0) {
    return <List>{t`No results found`}</List>;
  }
  
  return (
    <>
      <List>
        {options.results && Array.isArray(options.results) && options.results.map((result, index) => (
        result &&  <ListItem
            key={result.id}
            onClick={() => options.handleSelect(result)}
            className={options.activeIndex === index ? "active" : ""}
          >
            {result.name &&  typeof result.name === 'string' && <> 
            {matchedTerm(result.name, options.searchTerm)} <span> {result.address && `- ${result.address}`}</span><span>{result.emoji}</span>
            </>}
          </ListItem>
        ))}
      </List>
    </>
  );
}

export default ResultList;